import React, { useState, useEffect } from "react";
import moment from "moment";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import { Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { selectPaymentLocation } from "../../redux/slice/paymentLocations";
import { customStyles, extract_time, formatNumber } from "../../utils/data/essential";
import { transferHeaders } from "../../utils/data/reportData";
import { useFetchData } from "../../hooks/useFetchData";
import Locations from "../../Component/Locations";
import { columns } from "../../utils/columns/Transfers";

const TransferReport = () => {
  const [transferData, setTransferData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());

  const user = JSON.parse(localStorage.getItem("user"));
  const userLocations = JSON.parse(localStorage.getItem("locations"));
  const [locationId, setLocationId] = useState(userLocations[userLocations.length -1].id);
  const startdate = moment(fromDate).format("YYYY-MM-DD");
  const enddate = moment(toDate).format("YYYY-MM-DD");

  const [payee, setPayee] = useState(null);
  const locations = useSelector(selectPaymentLocation);
  
  const extractData = (data) => {
    const arr = [];
    let obj = {};
    data?.forEach((dt) => {
      obj.id = dt.id;
      obj.payee = payee;
      obj.tid = dt.transactionId;
      obj.collectionAccount = dt.collectionAccount.name;
      obj.payeeNumber = dt.payee.payeeNumber;
      obj.amount = `${formatNumber(dt.amount)} RWF`;
      obj.transferAccountId = dt.transferAccountId;
      obj.status = dt.status.name;
      obj.info = dt.transferInfo;
      obj.prid = dt.processingReferenceId;
      obj.frid = dt.financialReferenceId;
      obj.type = dt.type.name;
      obj.datetime = moment(dt.datetime).format("DD-MM-YYYY hh:mm:ss A");
      arr.push(obj);
      obj = {};
    });
    setTransferData(arr);
  };

  // Fetch transfers data
  const url = `payments/transfers?location=${locationId}&startdate=${startdate}&enddate=${enddate}`;
  const { data, refetch } = useFetchData(
    ["fetch-transfers"],
    url,
    false,
    user

  );

  useEffect(() => {
    setPayee(locations[locations?.length - 1]?.name)
  },[locations])
  useEffect(() => {
    setLoading(false);
    extractData(data)
  }, [data]);

  const handleDataFromLocationsComponent = (data) => {
    if (locations.length >= 3) {
      setLocationId(locations[2].id);
    } else {
      setLocationId(data?.locationId);
    }
    setLocationId(data?.locationId);
  };

  return (
    <div>
      <div className='d-flex justify-content-center mt-3'>
        <h3>Transfers</h3>
      </div>
      <Locations
        isFullLocation={false}
        sendDataToParent={handleDataFromLocationsComponent}
      />
      <div className='d-flex flex-wrap justify-content-center mt-4'>
        <div className='d-flex payment-date'>
          <label className='mr-2 mt-2'>From:</label>
          <DatePicker
            className='form-control mr-2 h-100 input-select'
            selected={fromDate}
            onChange={(date) => setFromDate(date)}
            dateFormat='dd/MM/yyyy'
          />
        </div>
        <div className='d-flex payment-date'>
          <label className='mr-2 mt-2'>To:</label>
          <DatePicker
            className='form-control mr-2 h-100 input-select'
            selected={toDate}
            onChange={(date) => setToDate(date)}
            dateFormat='dd/MM/yyyy'
          />
        </div>
      </div>
      <div className='d-flex justify-content-center ml-5'>
        <Button
          onClick={() => {
            setLoading(true);
            refetch();
          }}
          className='custom-btn-color'
          style={{
            marginLeft: "7%",
          }}
        >
          {loading ? "Loading..." : "Search"}
        </Button>
      </div>
      {transferData?.length > 0 && (
        <div className='d-flex justify-content-end mr-3 mt-2'>
          <CSVLink
            data={transferData}
            headers={transferHeaders}
            filename={`transfer_report_${extract_time()}`}
          >
            <button
              type='button'
              className='btn btn-primary housesTableFilterBtn'
              disabled={transferData.length === 0}
              style={{
                backgroundColor:
                  transferData.length === 0 ? "#cbcbcb" : "#124db1",
                color: transferData.length === 0 ? "#000" : "",
                cursor: transferData.length === 0 ? "default" : "pointer",
              }}
            >
              Excel{" "}
              <i
                style={{ marginLeft: "1rem" }}
                className='fas fa-file-excel'
              ></i>
            </button>
          </CSVLink>
        </div>
      )}
      <div className='table-responsive datatables dataValidation-Wrap thead-primary pr-3 pl-3 mr-2'>
        <DataTable
          columns={columns}
          data={transferData}
          responsive={true}
          customStyles={customStyles}
          pagination
          highlightOnHover
          numberiped
          noHeader
        />
      </div>
    </div>
  );
};

export default TransferReport;
